import * as React from 'react';
const __reactCreateElement__ = React.createElement;
import { useList } from './fixed-hooks';
import { getContainerStyle, defaultGetItemKey } from './utils';
export function List({
  items,
  width,
  height,
  overscanBy = 2,
  scrollTop,
  itemHeight,
  itemGap = 0,
  as: Container = 'div',
  id,
  className,
  style,
  role = 'list',
  tabIndex,
  itemAs: WrapperComponent = 'div',
  itemKey = defaultGetItemKey,
  isScrolling,
  onRender,
  innerRef,
  render: RenderComponent
}) {
  const children = useList({
    items,
    width,
    height,
    overscanBy,
    scrollTop,
    itemHeight,
    itemGap
  });
  const itemRole = role && role + 'item';
  const startIndex = children[0] ? children[0].index : 0;
  let stopIndex;
  let i = 0;

  for (; i < children.length; i++) {
    const child = children[i];
    stopIndex = child.index;
    children[i] = /*#__PURE__*/__reactCreateElement__(WrapperComponent, {
      key: itemKey(child.data, child.index),
      role: itemRole,
      style: child.style
    }, /*#__PURE__*/__reactCreateElement__(RenderComponent, {
      index: child.index,
      data: child.data,
      width: child.width,
      height: child.height
    }));
  } // Calls the onRender callback if the rendered indices changed


  React.useEffect(() => {
    if (typeof onRender === 'function' && stopIndex !== void 0) onRender(startIndex, stopIndex, items); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onRender, items, startIndex, stopIndex]);
  const containerStyle = getContainerStyle(isScrolling, (itemHeight + itemGap) * items.length - itemGap);
  return /*#__PURE__*/__reactCreateElement__(Container, {
    id: id,
    className: className,
    style: style !== void 0 ? Object.assign({}, containerStyle, style) : containerStyle,
    role: role,
    tabIndex: tabIndex,
    ref: innerRef,
    children: children
  });
}